module.exports = __webpack_public_path__ + "img/car3.a84edafe.png";